module.exports = __webpack_public_path__ + "static/media/workplace.7be2e33d.svg";